import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as _ from 'lodash';
import { catchError, map, switchMap } from 'rxjs/operators';

import { PassiveDocumentCreationActions } from '../actions';
import { OnboardingProductsService } from '../../services/onboarding-products.service';
import { Common } from './common';
import { of } from 'rxjs';
import { Store } from '@ngrx/store';
import { OnboardingProductsStore } from '../store';

@Injectable()
export class PassiveDocumentCreationEffects {
  constructor(
    private actions$: Actions,
    private onboardingProductsService: OnboardingProductsService,
    private store: Store<OnboardingProductsStore.AppState>
  ) {}

  private common = new Common();

  getPassiveDocumentCreation$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PassiveDocumentCreationActions.getPassiveDocumentCreation),
      switchMap((action) =>
        this.onboardingProductsService.getPassiveDocumentCreation(action.request).pipe(
          map((res) => this.common.responseInterpreter(res)),
          map((res) => res['middleware']),
          map((res) =>
          PassiveDocumentCreationActions.getPassiveDocumentCreationSucess({ response: res })
          ),
          catchError((error) =>
            of(
              PassiveDocumentCreationActions.getPassiveDocumentCreationError({
                payload: this.common.handleErrorsDefault(error)
              })
            )
          )
        )
      )
    )
  );
}
